import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { ItemsCopyrightFooter } from "../../../api/packbo/models/items-copyright-footer";
import { ItemsFooter } from "../../../api/packbo/models/items-footer";

type FooterState = {
    footerDefinition: ItemsFooter | null;
    copyrightDefinition: ItemsCopyrightFooter | null;
    submitMessage: string | null;
};

const initialState: FooterState = {
    footerDefinition: null,
    copyrightDefinition: null,
    submitMessage: null
};

export const FooterStore = signalStore(
    withState(initialState),
    withMethods((store) => ({
        setFooterDefinition(footerDefinition: ItemsFooter | null) {
            patchState(store, { footerDefinition });
        },
        setCopyrightDefinition(copyrightDefinition: ItemsCopyrightFooter | null) {
            patchState(store, { copyrightDefinition });
        },
        setSubmitMessage(submitMessage: string | null) {
            patchState(store, { submitMessage });
        }
    }))
);
